import { useState } from "react";
import "./Bloqpadr.css";

const VISIBLES = 3;
const PASO_PX = 220;

const Bloqpadr = ({ padre, hijos, renderCard }) => {
  const [inicio, setInicio] = useState(0);
  const total = hijos.length;
  const maxInicio = Math.max(0, total - VISIBLES);
  const inicioActual = Math.min(inicio, maxInicio);

  const irIzquierda = () => setInicio(Math.max(0, inicioActual - VISIBLES));
  const irDerecha = () => setInicio(Math.min(maxInicio, inicioActual + VISIBLES));

  const hayFlechas = total > VISIBLES;
  const offIzq = inicioActual <= 0;
  const offDer = inicioActual >= maxInicio;
  const desde = total === 0 ? 0 : inicioActual + 1;
  const hasta = Math.min(inicioActual + VISIBLES, total);

  return (
    <div className="bp-block">
      <div className="bp-hdr">
        <span className="bp-hdr__tipo">{padre.TIPODESX}</span>
        {total > 0 ? (
          <span className="bp-hdr__count">
            {total} hijo{total > 1 ? "s" : ""}
          </span>
        ) : (
          <span className="bp-hdr__noh">Sin hijos</span>
        )}
        {hayFlechas && (
          <span className="bp-hdr__nav">
            {desde} – {hasta} de {total}
          </span>
        )}
      </div>

      <div className="bp-row">
        <div className="bp-padre">{renderCard(padre)}</div>

        <div className="bp-sep">
          <span className="bp-sep__lbl">Hijos</span>
        </div>

        {total === 0 ? (
          <div className="bp-hijos">
            <div className="bp-nohijo">Sin documentos hijos</div>
          </div>
        ) : (
          <div className="bp-hijos">
            <button
              type="button"
              className={`bp-arrow ${offIzq ? "bp-arrow--off" : ""}`}
              onClick={irIzquierda}
              title="Anterior"
              disabled={offIzq}
            >
              ‹
            </button>
            <div className="bp-viewport">
              <div
                className="bp-track"
                style={{ transform: `translateX(-${inicioActual * PASO_PX}px)` }}
              >
                {hijos.map((hijo) => (
                  <div className="bp-hijo" key={hijo.IDARCHXX}>
                    {renderCard(hijo)}
                  </div>
                ))}
              </div>
            </div>
            <button
              type="button"
              className={`bp-arrow ${offDer ? "bp-arrow--off" : ""}`}
              onClick={irDerecha}
              title="Siguiente"
              disabled={offDer}
            >
              ›
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Bloqpadr;
